import { useEffect } from 'react';
import axios from 'axios';
import { publicUploadUrl } from '../utils/mediaUrls';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const FaviconUpdater = () => {
  useEffect(() => {
    // Hide default favicon immediately to prevent flash
    const defaultFavicon = document.querySelector('link[rel="icon"]');
    const defaultAppleIcon = document.querySelector('link[rel="apple-touch-icon"]');
    
    if (defaultFavicon) {
      defaultFavicon.style.display = 'none';
    }
    if (defaultAppleIcon) {
      defaultAppleIcon.style.display = 'none';
    }

    const updateFavicon = async () => {
      try {
        const response = await axios.get(`${apiUrl}/settings`);
        const settings = response.data;
        
        if (settings.site_favicon) {
          // Fetch favicon media details
          try {
            const mediaResponse = await axios.get(`${apiUrl}/media`);
            const faviconMedia = mediaResponse.data.find(m => m.id === parseInt(settings.site_favicon));
            if (faviconMedia) {
              const faviconUrl = publicUploadUrl(faviconMedia.filename);
              
              // Remove existing favicon links (including default ones)
              const existingLinks = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]');
              existingLinks.forEach(link => link.remove());
              
              // Create new favicon link
              const link = document.createElement('link');
              link.rel = 'icon';
              link.type = faviconMedia.filetype || 'image/x-icon';
              link.href = faviconUrl;
              document.head.appendChild(link);
              
              // Also update apple-touch-icon
              const appleLink = document.createElement('link');
              appleLink.rel = 'apple-touch-icon';
              appleLink.href = faviconUrl;
              document.head.appendChild(appleLink);
            } else {
              // Custom favicon ID set but media not found, show default
              if (defaultFavicon) defaultFavicon.style.display = '';
              if (defaultAppleIcon) defaultAppleIcon.style.display = '';
            }
          } catch (err) {
            console.error('Error fetching favicon media:', err);
            // Show default on error
            if (defaultFavicon) defaultFavicon.style.display = '';
            if (defaultAppleIcon) defaultAppleIcon.style.display = '';
          }
        } else {
          // No custom favicon set, show default
          if (defaultFavicon) defaultFavicon.style.display = '';
          if (defaultAppleIcon) defaultAppleIcon.style.display = '';
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
        // Show default on error
        if (defaultFavicon) defaultFavicon.style.display = '';
        if (defaultAppleIcon) defaultAppleIcon.style.display = '';
      }
    };

    // Run immediately
    updateFavicon();
  }, []);

  return null; // This component doesn't render anything
};

export default FaviconUpdater;
